<template>
	<div class="c-detail-item flex" :style="{'width': full ? '100%' : '50%'}">
		<label class="c-detail-item-label flex"><b v-if="required">*</b>{{label}}</label>
		<div class="c-detail-item-content flex-grow">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			
			required: Boolean,
			
			full: Boolean
		}
	};
</script>